import type { useAui } from "@assistant-ui/react";

import type { RetryContextValue } from "../contexts/RetryContext";

type Aui = ReturnType<typeof useAui>;

/**
 * Arm the one-shot retry channel and start the replay run.
 *
 * The one-shot names the ASSISTANT message: the server replays the preceding
 * user turn itself. Branching from the parent user turn is what makes the
 * replaced answer a sibling branch locally instead of leaving a stale message
 * beside the fresh one. A failed start rolls the one-shot back so the next
 * composer-sent turn is not silently routed to the retry endpoint.
 */
export function startRecoveryRetry(
    aui: Aui,
    retryTarget: RetryContextValue,
    messageId: number,
    parentId: string
): void {
    retryTarget.setRetryTargetMessageId(messageId);
    try {
        aui.thread().startRun({ parentId });
    } catch (err) {
        retryTarget.setRetryTargetMessageId(undefined);
        console.error("retry could not be started", err);
    }
}
